import {
  BannersApi,
  BannersV1ActionsListRequest,
  InlineResponse2002
} from '@/requests/mainApi'
import { IResponse, requestMachine } from '@/requests/requestMachine'

export default {
  getActions (variables: BannersV1ActionsListRequest): Promise<IResponse<InlineResponse2002>> {
    return requestMachine<InlineResponse2002, BannersV1ActionsListRequest>(
      BannersApi,
      'bannersV1ActionsList',
      true,
      variables
    )
  },
  getActionMain (): Promise<IResponse<InlineResponse2002>> {
    return requestMachine<InlineResponse2002>(
      BannersApi,
      'bannersV1ActionMain',
      true
    )
  }
}
